import { useState, FC } from 'react';
import {
  Button,
  Divider,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Collapse,
  List
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ExpandMore, ExpandLess, Edit } from '@mui/icons-material';
import { IPartClass } from '../../../models/part-classes';

interface IPartClassItem {
  index: number;
  partClass: IPartClass;
}

export const PartClassItem: FC<IPartClassItem> = ({ index, partClass }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItem
        button
        classes={{
          root: classes.listItem
        }}
        onClick={() => handleClick()}
      >
        {partClass?.subPartClasses && partClass?.subPartClasses.length > 0 ? (
          <IconButton
            color="default"
            className={classes.openButton}
            aria-label="open"
            onClick={() => {
              setOpen(!open);
            }}
            size="large"
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        ) : null}
        <ListItemText primary={partClass.name} secondary={partClass.code} />
        <ListItemSecondaryAction className={classes.buttonWrapper}>
          <Button
            startIcon={<Edit />}
            color="primary"
            variant={'contained'}
            className={classes.editButton}
            onClick={() => alert('Edit')}
          >
            Edit
          </Button>
        </ListItemSecondaryAction>
      </ListItem>

      <>
        <Divider />
        <Collapse in={open} timeout="auto" unmountOnExit className={classes.nested}>
          <List component="div" disablePadding>
            {partClass?.subPartClasses.map((partClass, newIndex) => {
              return (
                <PartClassItem key={partClass.partClassId} index={newIndex} partClass={partClass} />
              );
            })}
          </List>
        </Collapse>
      </>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(2)
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2
  },
  listItemWithCats: {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: theme.spacing(1)
  },
  nestedListItemWithCats: {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: theme.spacing(2)
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    fontWeight: 'bold',
    padding: `2px 8px`,
    borderRadius: 5,
    marginRight: 0
  },
  openButton: {
    padding: 0
  },
  selected: {
    fontWeight: 'bold',
    padding: `2px 8px`,
    borderRadius: 5,
    marginRight: 0
  }
}));
